// Read More control
// eg.
// <div class="read-more" data-controller="readmore">
//    <div data-target="readmore.preview"></div>
//    <div data-target="readmore.full" style="display:none;"></div>
//    <a href="javascript:void(0)" data-target="readmore.expand" data-action="readmore#toggle">Read More</a>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "expand" ]

  readonly previewTarget!: HTMLElement
  readonly fullTarget!: HTMLElement
  readonly expandTargets!: HTMLElement[]

  expanded: boolean = false

  toggle() {
    this.expanded = !this.expanded

    if (this.expanded) {
      this.previewTarget.style.display = 'none'
      this.fullTarget.style.display = 'block'
      this.fullTarget.parentElement.classList.add('read-more--expanded')

      this.expandTargets.forEach(e => {
        e.innerHTML = `Read Less  <i class="fa fa-caret-up"></i>`
      })
    } else {
      this.previewTarget.style.display = 'block'
      this.fullTarget.style.display = 'none'
      this.fullTarget.parentElement.classList.remove('read-more--expanded')

      this.expandTargets.forEach(e => {
        e.innerHTML = `Read More <i class="fa fa-caret-down"></i>`
      })
    }
  }
}